<template>
  <div class="page-job">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/ah/hiring`"
          >招工招生</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ metaData.name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content content" v-loading="loading">
        <job-card
          v-for="item in jobList"
          :data="item"
          :key="item.id"
        ></job-card>
        <el-pagination
          v-if="total > pageSize"
          class="g-pagination"
          background
          layout="prev, pager, next"
          :current-page="pageIndex"
          :page-size="pageSize"
          :total="total"
          @current-change="handleIndexChange"
        >
          ></el-pagination
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getData } from "api/app";
import Card from "./Card";
export default {
  data() {
    return {
      metaData: {
        name: "招聘岗位"
      },
      jobList: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      loading: false
    };
  },
  created() {
    this.init();
  },
  components: {
    [Card.name]: Card
  },
  methods: {
    handleIndexChange(index) {
      this.pageIndex = index;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      var queryParams = {
        name: "RecruitJob",
        index: this.pageIndex,
        size: this.pageSize ?? 10
      };
      getData(queryParams)
        .then(res1 => {
          const arr = [];
          if (res1.Data) {
            getData({ name: "Job" }).then(res2 => {
              res1.Data.forEach(item => {
                const Salary = [];
                const Enterprise = [];
                const Education = [];
                res2.forEach(i => {
                  if (i.Id === item.JobId) Salary.push(i.Salary);
                  Enterprise.push(i.Enterprise);
                  Education.push(i.Education);
                });
                arr.push({
                  PostName: item.JobName,
                  Salary: Salary[0],
                  Enterprise: Enterprise[0],
                  Workplace: item.Address,
                  Education: Education[0],
                  IssueTime: item.CreatedTime,
                  HiringCount: item.RecruitCount,
                  Id: item.Id
                });
              });
            });
          }
          this.loading = false;
          this.jobList = arr || [];
          this.total = res1.TotalCount;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    init() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-job {
  background: #f6f6f9;
  padding-bottom: 40px;
  ::v-deep .comp-job {
    margin: 0 48px;
  }
  .content {
    padding-bottom: 48px;
    .g-pagination {
      margin-top: 24px;
    }
  }
}
</style>
